import type { TFunction } from "i18next";
import { z } from "zod";

const LANG_BASE = "vessel-call.shipping-agency-transfer";

export const REJECTION_REASON_MAX_LENGTH = 1000;

export const reasonSchema = (t: TFunction) =>
  z.object({
    reason: z
      .string()
      .trim()
      .max(
        REJECTION_REASON_MAX_LENGTH,
        t(`${LANG_BASE}.rejection-reason-max-length-error`, {
          max: REJECTION_REASON_MAX_LENGTH,
        }),
      )
      .min(1, t(`${LANG_BASE}.rejection-reason-required`)),
  });
